import React, { useState } from 'react';
import { API } from './api';

// Public page reached from an association-admin invite link: /set-password?token=...
export default function SetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setSubmitting(true);
    try {
      const res = await fetch(`${API}/api/associations/set-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ invite_token: token, password }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Could not set password.');
      }
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center px-4">
      <div className="bg-[#1A2744] rounded-xl border border-[#546E7A]/30 p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <span className="font-bold text-white text-2xl">Scheme</span>
          <span className="font-bold text-[#00D4FF] text-2xl">Sync</span>
          <p className="text-[#B0BEC5] mt-2">Set your password</p>
        </div>
        {done ? (
          <div className="text-center">
            <p className="text-[#00E676] mb-4">Your password has been set.</p>
            <a href="/" className="text-[#00D4FF] underline">Go to login →</a>
          </div>
        ) : !token ? (
          <p className="text-red-400 text-center">Missing invite token. Please use the link from your invitation.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm text-[#B0BEC5] mb-1">New password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 rounded-md bg-[#0A0E27] border border-[#546E7A]/40 text-white" />
            </div>
            <div>
              <label className="block text-sm text-[#B0BEC5] mb-1">Confirm password</label>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                className="w-full px-3 py-2 rounded-md bg-[#0A0E27] border border-[#546E7A]/40 text-white" />
            </div>
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <button type="submit" disabled={submitting}
              className="w-full py-2 rounded-md bg-[#00D4FF] text-[#0A0E27] font-semibold disabled:opacity-50">
              {submitting ? 'Setting…' : 'Set Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
